import { picoapp } from 'picoapp'

// snippets
import accountLogin from '@/snippets/accountLogin.js'
import addToCart from '@/snippets/add-to-cart.js'
import cart from '@/snippets/cart.js'
import cartDrawerItem from '@/snippets/cartDrawerItem.js'
import cartRedirect from '@/templates/cart-redirect.js'
import contentAccordion from '@/snippets/content-accordion.js'
import imageCompareViewer from '@/snippets/image-compare-viewer.js'
import header from '@/snippets/header.js'
import heroCarousel from '@/snippets/hero-carousel.js'
import loopingVideo from '@/snippets/looping-video.js'
import product from '@/snippets/product.js'
import productCarousel from '@/snippets/product-carousel.js'
import productCounter from '@/snippets/product-counter.js'
import productSelection from '@/snippets/product-selection.js'
import featuredReviews from '@/snippets/featured-reviews.js'
import marqueeLogos from '@/snippets/marquee-logos.js'
import hashScroll from '@/snippets/hash-scroll.js'

// state
const state = {
  router: null,
  pjax: false,
  cartOpen: false,
  loadURL: ''
}

// components
const components = {
  accountLogin,
  addToCart,
  cart,
  cartDrawerItem,
  cartRedirect,
  contentAccordion,
  imageCompareViewer,
  header,
  heroCarousel,
  loopingVideo,
  product,
  productCarousel,
  productCounter,
  productSelection,
  featuredReviews,
  marqueeLogos,
  hashScroll
}

export default picoapp(components, state)
